<template>
    <div style="display:initial">
        <!-- 各平台篩選按鈕 -->
        <template v-for="(item,index) in items">
            <tg-button
                v-if="showAllThirdPartyBtn || index < 5"
                :classes="['tg-icon-circle']"
                style="display:initial !important;"
                round
                icon="times"
                @click.native="cancelThirdPartyCheckBox(item)"
                :key="item.key"
                :disabled="value.length == 1"
            >
                {{ item.text}}
            </tg-button>
        </template>

        <!-- 摺疊/顯示開關 -->
        <template v-if="value.length > 5">
            <span @click="changeShowAllThirdPartyBtn()">
                <i :class="['tg-icon tg-icon-arrow',{mirrorRotateLevel:showAllThirdPartyBtn}]" ></i>
            </span>
        </template>
    </div>

</template>

<script>
import TgButton from "@/components/button/TgButton";

export default {
    components: {
        TgButton
    },
    props: {
        value: Array,
    },
    data(){
        return {
            showAllThirdPartyBtn:false,
        }
    },
    computed: {
        isThirdParty () {
            return this.value && this.value.length > 0 && 'platform' in this.value[0];
        },
        items () {
            let items = [...this.value];

            if (this.isThirdParty) {
                items = items.map(item => {
                    return {
                        key: item.platform,
                        text: this.$t("component.label.source_type."+item.platform)
                    }
                });
            }
            return items;
        }
    },
    methods: {
        cancelThirdPartyCheckBox(item){

            let third_party = this.items.filter(x => {
                return this.isThirdParty ? x.platform != item.platform : x.key != item.key;
            })
            
            if(Object.keys(third_party).length == 0){
                third_party[0] = item;
            }

            this.$nextTick(() => {
                this.$emit("on-change", third_party);
            });
        },
        changeShowAllThirdPartyBtn(){
            this.showAllThirdPartyBtn = !this.showAllThirdPartyBtn;
            return this.showAllThirdPartyBtn;
        }
    },
};
</script>